<!--
Zukünftig links Full-height-Menue:
- wide Screen immer da (schiebt den rest nach recht)
- kleiner Screen menü weg  dafür Burger menü
- klick auf Burder menü opend Menü, overlyed aber Content
-->

<div class="menue">
  <!-- Menue Content goes here -->
</div>
<div class="contentwrapper">
  <router-outlet />
  <rr-disclaimer
      [type]="disclaimerTypes"
      [showIcon]="false"
      class="col w100"
  ></rr-disclaimer>
</div>
